export default "__VITE_ASSET__B84V5O7H__"